var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3125 2.03125C17.6562 4 17.3125 7.21875 15.6562 8.9375L10.1562 14.5312C9.84375 14.8438 9.4375 15.0312 9 15.0312C8.53125 15.0312 8.125 14.8438 7.8125 14.5312L2.34375 8.9375C0.65625 7.21875 0.3125 4 2.65625 2.03125C4.46875 0.5 7.25 0.71875 9 2.5C10.7188 0.71875 13.5 0.5 15.3125 2.03125ZM14.5625 7.875C15.7188 6.71875 15.9375 4.53125 14.3438 3.15625C13.125 2.15625 11.25 2.3125 10.0938 3.5L9 4.625L7.90625 3.5C6.71875 2.3125 4.84375 2.15625 3.625 3.1875C2.03125 4.53125 2.25 6.71875 3.40625 7.875L8.875 13.4688C8.96875 13.5312 9.03125 13.5312 9.09375 13.4688L14.5625 7.875Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeIcon);
export default __webpack_public_path__ + "static/media/likeIcon.29a084c01b5dcc4da5a799f152cbfcef.svg";
export { ForwardRef as ReactComponent };